
import { useEffect } from 'react';
import { AiOutlineClose } from 'react-icons/ai'
import { Button } from '../component/Button'
import { Card } from '../component/Card'
import { useDispatch, useSelector } from 'react-redux';
import { UserGetWishList, UserRemoveWishList } from '../redux/user/wish_list/wish_list_services_sync';
import { UserMajorCartCreation } from '../redux/user/cart/cartServicesSync';
import { updateWishListRemoveIndicator } from '../redux/user/wish_list/wish_list_slices';
import { InfinitySpin } from 'react-loader-spinner';
import { UserGetCart } from '../redux/user/cart/cartServicesSync';
import { updateCartIndicator } from '../redux/user/cart/cartSlices';
import Newsletter from '../component/Newsletter';


export default function WishlistPage() {
    const dispatch = useDispatch();
    const { wish_list, wishListRemoveIndicator } = useSelector((state) => state.user_wish_list);

    const { cartIndicator } = useSelector((state) => state.user_cart);

    useEffect(() => {
        dispatch(UserGetWishList());
    }, [dispatch]);

    const handleRemoveFromWishlist = (productId) => {
        dispatch(updateWishListRemoveIndicator(productId));
        dispatch(UserRemoveWishList({ cartId: productId }))
            .then(() => {
                dispatch(UserGetWishList());
                dispatch(updateWishListRemoveIndicator(''));
            });
    };

    const handleAddToCart = (item) => {
        dispatch(updateCartIndicator(item.product));

        dispatch(
            UserMajorCartCreation({
                productId: item.product,
                quantity: 1,
            })
        )
            .then(() => {
                dispatch(UserGetCart());
                dispatch(updateCartIndicator(''));
            })
            .catch(() => {
                dispatch(updateCartIndicator(''));
            });
    };

    return (
        <div className="main__content_wrapper">
            {/* Hero Section */}
            <section className="breadcrumb__section breadcrumb__bg">
                <div className="container">
                    <div className="row row-cols-1">
                        <div className="col">
                            <div className="breadcrumb__content">
                                <h1 className="breadcrumb__content--title text-white mb-10">
                                    Wishlist
                                </h1>
                                <ul className="breadcrumb__content--menu d-flex">
                                    <li className="breadcrumb__content--menu__items">
                                        <a className="text-white" href="/">Home</a>
                                    </li>
                                    <li className="breadcrumb__content--menu__items">
                                        <span className="text-white">Wishlist</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Wishlist Section */}
            <section class="cart__section section--padding">
                <div class="container">
                    <div class="cart__section--inner">

                        {/* Desktop View */}
                        <div className="hidden md:block">
                            <table className="w-full">
                                <thead>
                                    <tr className="border-b">
                                        <th className="text-left py-4">PRODUCT</th>
                                        <th className="text-left py-4">PRICE</th>
                                        <th className="text-left py-4">STOCK STATUS</th>
                                        <th className="text-left py-4">ADD TO CART</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {wish_list?.products?.map((item) => (
                                        <tr key={item._id} className="border-b">
                                            <td className="py-4">
                                                <div className="flex items-center gap-4">
                                                    {item._id === wishListRemoveIndicator ? (
                                                        <InfinitySpin width="80" color="#F61B1C" />
                                                    ) : (
                                                        <button
                                                            className="text-gray-400 hover:text-red-600 shadow-2xl bg-white"
                                                            onClick={() => handleRemoveFromWishlist(item.product)}  
                                                        >
                                                            <AiOutlineClose className="cart__remove--btn" />
                                                        </button>

                                                    )}
                                                    <div className="cart__thumbnail">
                                                        <img
                                                            src={item.gallery?.[0]?.pic_url || "/placeholder.svg"}
                                                            alt={item.product_name}
                                                            className="border-radius-5"
                                                        />
                                                    </div>
                                                    <div>
                                                        <h3 className="font-semibold text-2xl">{item.product_name}</h3>
                                                        <p className="cart__content--variant">Price: {item.symbol}     
                                                             {Number(item.price).toLocaleString('en-NG', {
                                                                minimumFractionDigits: 0,
                                                                maximumFractionDigits: 2,
                                                                })}</p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="py-4 font-semibold text-black">{item.symbol}
                                                      {Number(item.price).toLocaleString('en-NG', {
                                                    minimumFractionDigits: 0,
                                                    maximumFractionDigits: 2,
                                                    })}
                                            </td>
                                            <td className="py-4">
                                                <span className="text-red-500">in stock</span>
                                            </td>
                                            <td className="py-4">
                                                {item.product === cartIndicator ? (
                                                    <button className="w-full bg-red-500 text-white py-[0.35rem] flex items-center justify-center gap-2 mt-auto">
                                                        <InfinitySpin width="80" color="#FFFFFF" />
                                                    </button>
                                                ) : (
                                                    <Button
                                                        className="bg-red-600 hover:bg-black text-white font-semibold"
                                                        onClick={() => handleAddToCart(item)}
                                                    >
                                                        Add To Cart
                                                    </Button>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Mobile View */}
                        <div className="md:hidden space-y-4">
                            {wish_list?.products?.map((item) => (
                                <Card key={item._id} className="p-4">
                                    <div className="flex justify-between items-start mb-4">
                                        <img
                                            src={item.gallery?.[0]?.pic_url || "/placeholder.svg"}
                                            alt={item.product_name}
                                            className="w-20 h-20 object-cover"
                                        />
                                        <button
                                            className="text-gray-400 hover:text-gray-600"
                                            onClick={() => handleRemoveFromWishlist(item.product)}
                                        >
                                            <AiOutlineClose size={20} />
                                        </button>
                                    </div>
                                    <div className="space-y-2">
                                        <h3 className="font-medium">{item.product_name}</h3>
                                        <p className="font-medium">{item.symbol}
                                            {Number(item.price).toLocaleString('en-NG', {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 2,
                                            })}
                                        </p>
                                        <p className="text-red-500">in stock</p>
                                        <Button
                                            className="w-full bg-red-500 hover:bg-red-600 text-white"
                                            onClick={() => handleAddToCart(item)}
                                        >
                                            {item.product === cartIndicator ? (
                                                <InfinitySpin width="80" color="#FFFFFF" />
                                            ) : (
                                                'Add To Cart'
                                            )}
                                        </Button>
                                    </div>
                                </Card>
                            ))}
                        </div>

                    </div>
                </div>
            </section>
            <Newsletter />
        </div>
    )
}
